export function sortSessionsWithTopics(sessions) {
  return [...sessions].reverse().sort((a, b) => {
    const [aHours, aMinutes] = a.start.split(":").map(Number);
    const [bHours, bMinutes] = b.start.split(":").map(Number);
    return aHours * 60 + aMinutes - (bHours * 60 + bMinutes);
  });
}
